export default "__VITE_ASSET__D9m5Rw22__"